import {
  IconDefinition,
  faBookmark,
  faEdit,
  faTrashAlt,
  faListAlt,
  faCheckCircle,
  faUser,
  faCopyright,
  faMap,
  faEnvelope,
  faCompass,
  faCommentAlt,
  faBuilding,
  faSave,
  faIdCard,
  faCalendarAlt,
  faPlayCircle,
  faClone,
  faEye,
} from '@fortawesome/free-regular-svg-icons'
import { faMinus } from '@fortawesome/free-solid-svg-icons'

export const regularIcons: Array<IconDefinition> = [
  faEdit,
  faTrashAlt,
  faBookmark,
  faListAlt,
  faCheckCircle,
  faCopyright,
  faMap,
  faEnvelope,
  faCompass,
  faCommentAlt,
  faBuilding,
  faSave,
  faIdCard,
  faCalendarAlt,
  faPlayCircle,
  faUser,
  faClone,
  faMinus,
]
